import React, { useEffect, useState } from 'react';
import BASE_URL from '../config';

const ShowHensen = () => {
  const [records, setRecords] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log(`${BASE_URL}api/proxy?action=latest_hensendata`);
        const res = await fetch(`${BASE_URL}api/proxy?action=latest_hensendata`);
        const data = await res.json();

        // Normalize response handling
        let finalData = [];

        if (Array.isArray(data)) {
          finalData = data;
        } else if (Array.isArray(data.data)) {
          finalData = data.data;
        } else if (Array.isArray(data.result)) {
          finalData = data.result;
        } else if (Array.isArray(data.records)) {
          finalData = data.records;
        }

        if (finalData.length > 0) {
          setRecords(finalData);
        } else {
          console.warn('Unexpected API format:', data);
          setError('No valid data found.');
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setError('Failed to fetch data.');
      }
    };

    fetchData();
  }, []);

  return (
    <div className="container mt-4">
      <h5>Latest Hensen Records</h5>
      {error && <div className="alert alert-danger">{error}</div>}

      <div
        className="table-responsive"
        style={{ maxHeight: '400px', overflowY: 'auto' }}
      >
        <table
          className="table table-striped table-bordered table-sm"
          style={{ fontFamily: 'Arial', whiteSpace: 'nowrap' }}
        >
          <thead className="thead-dark">
            <tr>
              {records.length > 0 &&
                Object.keys(records[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
            </tr>
          </thead>
          <tbody>
            {records.map((row, idx) => (
              <tr key={idx}>
                {Object.values(row).map((value, i) => (
                  <td key={i}>{String(value)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShowHensen;
